import React, { useState, useContext } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';

const BTab = styled(Tab)(({ theme }) => ({
  fontFamily: 'Akkurat',
  color: '#a2a2a2',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 400,
  backgroundColor: 'transparent',
  borderBottom: '3px solid #FFFFFF !important',
  width: '132px',
  lineHeight: 1.5,
  padding: '6px',
  margin: '6px',
  border: 'none',
  borderRadius: '0px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginInlineEnd: '20px',
  padding: '0px',

  '&:hover': {
    color: '#292d32',
    borderBottom: '3px solid #292D32',
  },

  '&.Mui-selected': {
    color: '#292D32',
    borderBottom: '3px solid #292D32',
    marginInlineEnd: '20px',
    padding: '0px',
  },
}));

const ScrollableTabs = ({
  tabs,
  onTabChange,
  initialTab = 0,
  maxWidth = { xl: 1260 },
}) => {
  const [value, setValue] = useState(initialTab);
  const { locale } = useContext(LocaleContext);

  const direction = locale === 'ar' ? 'rtl' : 'ltr';

  const theme = createTheme({
    direction: direction,
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onTabChange) {
      onTabChange(newValue); // Notify parent component of tab change
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          maxWidth,
          borderBottom: 1,
          borderColor: 'divider',
          dir: direction,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable tabs"
          TabIndicatorProps={{
            style: { backgroundColor: '#292D32' }, // Customize indicator
          }}
        >
          {tabs.map((tab, index) => (
            <BTab
              key={index}
              label={tab.label}
              icon={
                tab.icon ? (
                  <img
                    className={index === value ? '' : 'changeIconColor'}
                    src={tab.icon}
                    alt="icon"
                    style={{ maxHeight: '70px', maxWidth: '70px' }}
                  />
                ) : null
              }
            />
          ))}
        </Tabs>
      </Box>
    </ThemeProvider>
  );
};

export default ScrollableTabs;
